import * as types from './mutation-types'

export default {
  [types.AUTH_LOGIN] (state, payload) {
    state.user = payload.id
    state.username = payload.user
  },

  [types.AUTH_LOGOUT] (state, payload) {
    state.user = payload
    state.username = payload
  }

}
